import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from '@mui/material';
import { Column, Row } from '../atoms/boxes';
export const PageHeader = props => {
    return (_jsxs(Column, { children: [_jsx(Row, { p: 2, minHeight: 68, alignItems: "center", ...props }), _jsx(Divider, {})] }));
};
